// extracted by mini-css-extract-plugin
export default {"spinnerOverlay":"Spinner_spinnerOverlay__kh-I8","spinnerContainer":"Spinner_spinnerContainer__JlLYR","spin":"Spinner_spin__I7dYH"};